import { useCallback } from 'react';

import {
	INSTANT_SEARCH_CACHE_SECONDS,
	INSTANT_SEARCH_LOCATION_CITY_FILTER,
	INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER,
} from '#src/app/pages/search/shared/consts';
import { useInstantSearchIndexName, useSearchClient } from '#src/app/pages/search/shared/hooks';

type Result = ModelHookResult<
	undefined,
	{
		resolveCityState: ({
			city,
			countryCode,
			stateCode,
		}: {
			city: string;
			countryCode: string;
			stateCode?: string;
		}) => Promise<string>;
	}
>;

export function useResolveCityState(): Result {
	const {
		data: { typesenseClient },
	} = useSearchClient();

	const {
		data: { instantSearchIndexName },
	} = useInstantSearchIndexName();

	return {
		actions: {
			resolveCityState: useCallback(
				async ({ city, countryCode, stateCode }) => {
					const response = await typesenseClient
						.collections(instantSearchIndexName)
						.documents()
						.search(
							{
								q: '*',
								query_by: '*',
								facet_by: INSTANT_SEARCH_LOCATION_CITY_FILTER,
								facet_query: `${INSTANT_SEARCH_LOCATION_CITY_FILTER}:${stateCode ? `${city}, ${stateCode}` : city}`,
								filter_by: `${INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER}:=[${countryCode}]`,
								max_facet_values: 1,
							},
							{ cacheSearchResultsForSeconds: INSTANT_SEARCH_CACHE_SECONDS },
						);

					const facetCount = response.facet_counts?.find(
						(facet) => facet.field_name === INSTANT_SEARCH_LOCATION_CITY_FILTER,
					);

					return facetCount?.counts?.[0]?.value ?? `${city}${stateCode ? `, ${stateCode}` : ''}, ${countryCode}`;
				},
				[instantSearchIndexName, typesenseClient],
			),
		},
	};
}
